import { MultipleChoice } from '@ulysses-inc/harami_api_client'
import { useCallback } from 'react'
import { useNotificationService } from 'src/features/notificationService/useNotificationService'
import { extractHttpErrorMessages } from 'src/state/middleware/saga/handleHttpError'
import { useMutationAddMultipleChoices } from '../api/useMutationAddMultipleChoices'

export const useAddMultipleChoices = () => {
  const { showNotification } = useNotificationService()
  const { mutate, isPending } = useMutationAddMultipleChoices()

  const addMultipleChoices = useCallback(
    (multipleChoices: MultipleChoice[], onSuccess: () => void) => {
      mutate(multipleChoices, {
        onSuccess,
        onError: (e: unknown) => {
          showNotification('選択肢の追加に失敗しました', {
            notificationType: 'error',
            duration: 5,
            description: extractHttpErrorMessages(e),
          })
        },
      })
    },
    [mutate, showNotification],
  )

  return {
    addMultipleChoices,
    isPendingAddMultipleChoices: isPending,
  }
}
